import React from "react";
import RootLayout from "../pages/RootLayout";
import ErrorPage from "../pages/Error";
import Home from "../pages/Home";

export const routes = [
    {
        path: "/",
        element: <RootLayout/>,
        errorElement: <ErrorPage/>,
        children: [
            {
                index: true,
                element: <Home/>
            },
        ]
    }
];
